<template>
  <base-card>
    <base-question text="Onde estes tamanhos serão cadastrados?" />

    <base-radio
      label="Tamanhos iguais nesta categoria"
      family="sizeslocation"
      class="mb_15"
      :value="targetItem.default_sizes"
      :option="true"
      @click="targetItem.default_sizes = true"
    />
    <base-radio
      label="Tamanhos diferentes por produto"
      family="sizeslocation"
      class="mb_25"
      :value="targetItem.default_sizes"
      :option="false"
      @click="targetItem.default_sizes = false"
    />

    <base-message class="gold">
      <span v-if="!!targetItem.default_sizes"
        >Tamanhos iguais para todos os produtos cadastrados nesta categoria / A
        definição dos tamanhos se aplicará de forma padrão a todos os produtos
        cadastrados.</span
      >
      <span v-else
        >Tamanhos específicos para cada produto cadastrado nesta categoria / A
        definição dos tamanhos será por produto, no cadastramento do
        mesmo.</span
      >
    </base-message>
  </base-card>
</template>

<script>
// components
import BaseCard from "@/components/Card";
import BaseRadio from "@/components/Radio";
import BaseQuestion from "@/components/Question";
import BaseMessage from "@/components/Message";

export default {
  components: {
    BaseCard,
    BaseRadio,
    BaseQuestion,
    BaseMessage
  },
  data() {
    return {};
  },
  props: {
    targetItem: { default: {} },
  }
};
</script>
